export default class TeamJoinRequest {
    public TeamJoinRequestId: number;
    public FromPerson: number;
    public ForTeam: number;
    public Allowed: boolean;
}
